import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthLayout, Field, SubmitBtn, ErrorMsg } from "@/pages/Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetUrl, setResetUrl] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setResetUrl(data.reset_url || "");
      setEmailSent(!!data.email_sent);
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Reset password" description="We'll send you a secure reset link.">
      {done ? (
        <div data-testid="forgot-success">
          <div className="bg-emerald-50 border border-emerald-200 text-emerald-700 text-sm px-3 py-3 mb-4">
            {emailSent
              ? "If that account exists, a reset link has been emailed to it."
              : "If that account exists, a reset link has been created."}
          </div>
          {resetUrl && (
            <div className="mb-4">
              <p className="text-xs uppercase tracking-widest font-medium text-slate-500 mb-1">
                Reset link
              </p>
              <a href={resetUrl} data-testid="reset-link-display"
                className="block text-xs font-mono break-all border border-slate-200 bg-white p-3 text-blue-700 hover:underline">
                {resetUrl}
              </a>
            </div>
          )}
          <Link to="/login" className="text-sm text-blue-700 hover:underline">← Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} data-testid="forgot-form">
          <ErrorMsg>{error}</ErrorMsg>
          <Field label="Email" type="email" required value={email} data-testid="forgot-email"
            onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
          <SubmitBtn loading={loading} data-testid="forgot-submit">Generate reset link</SubmitBtn>
          <Link to="/login" className="block mt-4 text-sm text-blue-700 hover:underline">← Back to sign in</Link>
        </form>
      )}
    </AuthLayout>
  );
}
